export default "__VITE_ASSET__BD800X4l__"